// Утилита для работы с cookies для темы
const THEME_KEY = 'darkMode';

// Функция для установки cookie
const setCookie = (name, value, days = 365) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

// Функция для получения cookie
const getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export const getSavedTheme = () => {
    const savedTheme = getCookie(THEME_KEY);
    return savedTheme ? JSON.parse(savedTheme) : false; // По умолчанию светлая тема
};

export const saveThemeToLocalStorage = (darkMode) => {
    setCookie(THEME_KEY, JSON.stringify(darkMode));
};

export const getSavedLanguage = () => {
    return localStorage.getItem('language') || 'ru'; // 'ru' — язык по умолчанию
};

export const saveLanguageToLocalStorage = (language) => {
    localStorage.setItem('language', language);
};

// Функции для работы с языком интерфейса
export const getSavedInterfaceLanguage = () => {
    return localStorage.getItem('interface_language') || 'ru'; // 'ru' — язык интерфейса по умолчанию
};

export const saveInterfaceLanguageToLocalStorage = (language) => {
    localStorage.setItem('interface_language', language);
};